import { useEffect } from "react";
import { useRoutes } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@material-ui/core";
import "./i18n";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import GlobalStyles from "./components/GlobalStyles";
import RTL from "./components/RTL";
import SplashScreen from "./components/SplashScreen";
import { gtmConfig } from "./config";
import useAuth from "./hooks/useAuth";
import useScrollReset from "./hooks/useScrollReset";
import useSettings from "./hooks/useSettings";
import gtm from "./lib/gtm";
import routes from "./routes";
import { createTheme } from "./theme";
import { RoutesProvider } from "./contexts/RoutesContext";

const App = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  const { i18n } = useTranslation();
  const auth = useAuth();
  useScrollReset();

  useEffect(() => {
    gtm.initialize(gtmConfig);

    const cookies = new Cookies();
    const language = cookies.get("language");

    if (language) {
      i18n.changeLanguage(language);
    }
  }, []);

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme
  });

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={settings.direction}>
        <SnackbarProvider dense maxSnack={3}>
          <RoutesProvider routes={routes}>
            <GlobalStyles />
            {auth.isInitialized ? content : <SplashScreen />}
          </RoutesProvider>
        </SnackbarProvider>
      </RTL>
    </ThemeProvider>
  );
};

export default App;
